export default __webpack_public_path__ + "static/media/hook.26ffd5a3.jpg";